import type { Pinia } from "pinia";
import type { InjectionKey } from "vue";

export const STORE_SERVICE_INJECTION_KEY: InjectionKey<Pinia> =
  Symbol("STORE_SERVICE");
